/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyAnswer } from '../models/SurveyAnswer'
import type { SurveyArray } from '../models/SurveyArray'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class SurveyService {
  /**
   * 👤 Get the ongoing survey if it exists
   * @returns any OK
   * @throws ApiError
   */
  public static getSurvey(): CancelablePromise<{
    data?: SurveyArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/survey',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 👤 Store the survey Response
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postSurveyAnswer(
    requestBody?: SurveyAnswer,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/survey/answer',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
}
